var map = {
	"./en/aboutPage.json": "1fc1",
	"./en/chapterDetails.json": "f208",
	"./en/contact.json": "95a0",
	"./en/events.json": "f9d3",
	"./en/featureEvent.json": "0139",
	"./en/footer.json": "ff2a",
	"./en/menu.json": "5a64",
	"./en/misc.json": "fa31",
	"./en/partners.json": "fdcf",
	"./en/team.json": "a9da",
	"./en/whatWeDo.json": "0801",
	"./it/aboutPage.json": "cf41",
	"./it/chapterDetails.json": "fd5d",
	"./it/contact.json": "3972",
	"./it/events.json": "737c",
	"./it/featureEvent.json": "4c55",
	"./it/footer.json": "da04",
	"./it/menu.json": "be2a",
	"./it/misc.json": "813a",
	"./it/partners.json": "7282",
	"./it/team.json": "f75f",
	"./it/whatWeDo.json": "7807"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b47a";